import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { PureComponent } from "react";
import HotdogHeaderComponent from "/components/enhancements/decorators/hotdog-header/hotdog-header-component";
import DirectoryHeaderContentComponent from "../directory-header-content/directory-header-content-component";
import { StyledDirectoryHeaderComponent } from "./directory-header-component.scss";
class DirectoryHeaderComponent extends PureComponent {
    render() {
        const { hotDogColor, textColor, title, subtitle, searchConfig, searchValue, onSearchChange, img } = this.props;
        return /*#__PURE__*/ _jsx(StyledDirectoryHeaderComponent, {
            className: "directory-header-component-wrapper",
            children: /*#__PURE__*/ _jsxs(HotdogHeaderComponent, {
                className: "directory-header-component",
                backgroundColor: "light-grey",
                hotdogColor: hotDogColor,
                children: [
                    /*#__PURE__*/ _jsx("div", {
                        className: "image-container",
                        children: /*#__PURE__*/ _jsx("img", {
                            src: img
                        })
                    }),
                    /*#__PURE__*/ _jsx(DirectoryHeaderContentComponent, {
                        title: title,
                        subtitle: subtitle,
                        textColor: textColor,
                        searchConfig: searchConfig,
                        searchValue: searchValue,
                        onSearchChange: onSearchChange
                    })
                ]
            })
        });
    }
}
export { DirectoryHeaderComponent as default };
